export const getLanguagesFromLinkedContent = (languageMap, currentLanguage) => {
  const languages = Object.keys(languageMap !== null && languageMap !== void 0 ? languageMap : {});
  if (!languages.length) {
    return [];
  }
  if (!languages.includes(currentLanguage.toUpperCase())) {
    languages.push(currentLanguage.toUpperCase());
  }
  languages.sort();
  return languages;
};